import { useEffect } from "react";
import { publicDocsUrl } from "@/lib/docs";

export default function DocsRedirect() {
  const dest = publicDocsUrl(typeof window === "undefined" ? "" : window.location.hash);

  useEffect(() => {
    window.location.replace(publicDocsUrl(window.location.hash));
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <p className="text-sm text-slate-500">
        Redirigiendo a{" "}
        <a href={dest} className="text-blue-800 underline">
          docs.emite.do
        </a>
        …
      </p>
    </div>
  );
}
